// This file was automatically generated from ptdata.reports.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.reports');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.refPanelLegalReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.reports.summary(opt_data, output);
  output.append(' reviewed on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.signDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.displayAbnormalResults = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var nameList22294 = opt_data.abnormalResultNames;
  var nameListLen22294 = nameList22294.length;
  for (var nameIndex22294 = 0; nameIndex22294 < nameListLen22294; nameIndex22294++) {
    var nameData22294 = nameList22294[nameIndex22294];
    output.append((opt_data.doHighlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(nameData22294)) : soy.$$escapeHtml(nameData22294)) : soy.$$escapeHtml(nameData22294), (! (nameIndex22294 == nameListLen22294 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.categoryNames = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var nameList22306 = opt_data.categoryNames;
  var nameListLen22306 = nameList22306.length;
  for (var nameIndex22306 = 0; nameIndex22306 < nameListLen22306; nameIndex22306++) {
    var nameData22306 = nameList22306[nameIndex22306];
    output.append((opt_data.doHighlight) ? ((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : '') : soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : '')? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : '') : soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : '').capitalize() : '') : (soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : ''? soy.$$escapeHtml(nameData22306)? soy.$$escapeHtml(nameData22306).toLowerCase() : ''.capitalize() : ''), (! (nameIndex22306 == nameListLen22306 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports._reportTypeName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.reportType == 'lab') ? (opt_data.doHighlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Labs')) : soy.$$escapeHtml('Labs')) : 'Labs' : (opt_data.reportType == 'imaging') ? (opt_data.doHighlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Imaging Results')) : soy.$$escapeHtml('Imaging Results')) : 'Imaging Results' : (opt_data.doHighlight) ? ((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : '')) : ( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : ''))? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : '')) : ( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : '')).capitalize() : '') : (( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : '')? ( (soy.$$escapeHtml(opt_data.reportType) && el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)]) ?  el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[soy.$$escapeHtml(opt_data.reportType)].nickname : '').capitalize() : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.clientGeneratedTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.lastManualEditTime && opt_data.categoryNames.length) {
    el8.template.ptdata.reports._reportTypeName(opt_data, output);
  } else {
    if (! opt_data.categoryNames.length) {
      el8.template.ptdata.reports._reportTypeName(opt_data, output);
    } else {
      el8.template.ptdata.reports.categoryNames(opt_data, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isUrgent) ? '!! STAT !! ' : '');
  if (opt_data.customTitle) {
    output.append(soy.$$escapeHtml(opt_data.customTitle));
  } else {
    el8.template.ptdata.reports.clientGeneratedTitle(opt_data, output);
  }
  output.append((opt_data.lastManualEditTime && opt_data.categoryNames.length) ? ' (with manually typed lab values)' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.reports.summary(opt_data, output);
  output.append(' ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.cardSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var iList22376 = opt_data.noteItems;
  var iListLen22376 = iList22376.length;
  for (var iIndex22376 = 0; iIndex22376 < iListLen22376; iIndex22376++) {
    var iData22376 = iList22376[iIndex22376];
    output.append(soy.$$escapeHtml(iData22376.text), (! (iIndex22376 == iListLen22376 - 1)) ? '; ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.collectedDate && ! opt_data.lastManualEditTime) {
    output.append('Collected ', (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collectedDate)) : ''), ' - ');
    el8.template.ptdata.reports.summary(soy.$$augmentData(opt_data, {doHighlight: true}), output);
  } else {
    el8.template.ptdata.reports.summary(soy.$$augmentData(opt_data, {doHighlight: true}), output);
    output.append(' - dated ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.noteListSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.abnormalResultNames.length) {
    output.append('<p class="el8AbnormalText el8ItalicText">');
    el8.template.ptdata.reports.displayAbnormalResults(soy.$$augmentData(opt_data, {doHighlight: true}), output);
    output.append('</p>');
  }
  if (opt_data.noteItems.length) {
    output.append('<p>');
    var itemList22407 = opt_data.noteItems;
    var itemListLen22407 = itemList22407.length;
    for (var itemIndex22407 = 0; itemIndex22407 < itemListLen22407; itemIndex22407++) {
      var itemData22407 = itemList22407[itemIndex22407];
      output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(itemData22407.text)) : soy.$$escapeHtml(itemData22407.text)), (! (itemIndex22407 == itemListLen22407 - 1)) ? '; ' : '');
    }
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.noteListSummaryNEW = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.noteItems.length) {
    var itemList22418 = opt_data.noteItems;
    var itemListLen22418 = itemList22418.length;
    for (var itemIndex22418 = 0; itemIndex22418 < itemListLen22418; itemIndex22418++) {
      var itemData22418 = itemList22418[itemIndex22418];
      output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(itemData22418.text)) : soy.$$escapeHtml(itemData22418.text)), (! (itemIndex22418 == itemListLen22418 - 1)) ? '; ' : '');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.abnormalSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.abnormalResultNames.length) {
    output.append('<span class="el8FeedItemAbnormalText">');
    el8.template.ptdata.reports.displayAbnormalResults(soy.$$augmentData(opt_data, {doHighlight: true}), output);
    output.append('</span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.reports.chartFeedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.reportType == 'lab') ? '<div class="el8FeedItemIconLab"></div>' : (opt_data.reportType == 'hospital') ? '<div class="el8FeedItemIconHospital"></div>' : (opt_data.reportType == 'imaging') ? '<div class="el8FeedItemIconImaging"></div>' : (opt_data.reportType == 'cardiac') ? '<div class="el8FeedItemIconCardiac"></div>' : (opt_data.reportType == 'legal') ? '<div class="el8FeedItemIconLegal"></div>' : (opt_data.reportType == 'consultation') ? '<div class="el8FeedItemIconConsult"></div>' : '<div class="el8FeedItemIconReport"></div>');
  if (!opt_sb) return output.toString();
};
